import React from "react";
import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";

import useActaModal from "../../hooks/useActaModal";

const SIZE_CLASS = {
  sm: "max-w-md",
  md: "max-w-lg",
  lg: "max-w-2xl",
  xl: "max-w-4xl",
  "2xl": "max-w-6xl",
};

export default function ActaModal({
  open = true,
  onClose,
  title,
  subtitle,
  eyebrow,
  children,
  footer,
  size = "md",
  placement = "center",
  closeDisabled = false,
  closeOnOverlay = true,
  closeOnEscape = true,
  className = "",
  bodyClassName = "",
  testId,
  labelledBy,
}) {
  const modal = useActaModal({
    open,
    onClose,
    closeOnOverlay: closeOnOverlay && !closeDisabled,
    closeOnEscape: closeOnEscape && !closeDisabled,
    lockBodyScroll: placement !== "right",
  });

  if (!open || typeof document === "undefined") return null;
  const titleId = labelledBy || (testId ? `${testId}-title` : undefined);

  return createPortal(
    <div
      className={["acta-modal-overlay fixed inset-0 z-[150] flex items-center", placement === "right" ? "pointer-events-none justify-end p-0" : "justify-center p-3 sm:p-6"].join(" ")}
      style={placement === "right" ? { background: "transparent", backdropFilter: "none" } : undefined}
      {...modal.overlayProps}
      data-acta-modal-root
    >
      <section
        className={[
          "acta-modal-surface flex w-full flex-col overflow-hidden",
          placement === "right" ? "acta-agent-side-panel pointer-events-auto h-[100dvh] w-full max-w-[480px] !max-h-[100dvh] !rounded-none" : (SIZE_CLASS[size] || SIZE_CLASS.md),
          className,
        ].join(" ")}
        {...modal.dialogProps}
        aria-modal={placement !== "right"}
        aria-labelledby={titleId}
        data-testid={testId}
      >
        {(title || subtitle || eyebrow) && (
          <header className="acta-modal-header">
            <div className="min-w-0">
              {eyebrow ? <div className="label-eyebrow">{eyebrow}</div> : null}
              {title ? <h2 id={titleId} className="acta-modal-title">{title}</h2> : null}
              {subtitle ? <p className="acta-modal-subtitle">{subtitle}</p> : null}
            </div>
            <button
              type="button"
              className="acta-modal-close"
              onClick={() => modal.requestClose("button")}
              disabled={closeDisabled}
              aria-label="Fermer"
            >
              <X size={19} weight="bold" />
            </button>
          </header>
        )}

        <div className={["acta-modal-body acta-modal-scroll", bodyClassName].join(" ")}>
          {children}
        </div>

        {footer ? <footer className="acta-modal-footer">{footer}</footer> : null}
      </section>
    </div>,
    document.body
  );
}
